import { render } from "./CircleProgress.vue?vue&type=template&id=2a66d507&scoped=true&lang=pug"
import script from "./CircleProgress.vue?vue&type=script&lang=js"
export * from "./CircleProgress.vue?vue&type=script&lang=js"

import "./CircleProgress.vue?vue&type=style&index=0&id=2a66d507&scoped=true&lang=sass"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a66d507"]])

export default __exports__